import { Route } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { DcsDocsComponent } from './docs.component';

export const docsRoute: Route = {
  path: 'docs',
  component: DcsDocsComponent,
  data: {
    pageTitle: 'global.menu.admin.apidocs'
  }
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/docs/docs.route.ts